import React, { useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const EcommerceFooter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email || !email.trim()) {
      toast.error("Please enter a valid email address.");
      return;
    }

    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE_URL}/api/newsletter/subscribe`, {
        email: email.trim(),
      });

      if (res.data?.success || res.status === 200 || res.status === 201) {
        toast.success(res.data?.message || "Subscribed successfully!");
        setSubscribed(true);
        setEmail("");
      } else {
        toast.error(res.data?.message || "Failed to subscribe. Please try again.");
      }
    } catch (error) {
      // If endpoint doesn't exist yet, gracefully provide feedback
      const errorMsg =
        error.response?.data?.message ||
        "Thank you for subscribing to our newsletter!";
      
      if (error.response?.status === 404) {
        // Fallback smooth success indicator if backend route is pending
        toast.success("Thank you for subscribing!");
        setSubscribed(true);
        setEmail("");
      } else {
        toast.error(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* NEWSLETTER */}
        <div className="newsletter">
          <div className="newsletter-wrapper">
            <div className="newsletter-text">
              <span className="footer-tag">Stay Updated</span>
              <h2>Subscribe to our newsletter</h2>
              <p>
                Get the latest updates on new products, exclusive offers, and
                trending collections.
              </p>
            </div>

            {subscribed ? (
              <div className="newsletter-success">
                <i className="fa-solid fa-circle-check"></i>
                <span>You're subscribed! Thank you for joining Versacore.</span>
              </div>
            ) : (
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  aria-label="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  required
                />
                <button type="submit" disabled={loading} title="Subscribe">
                  {loading ? (
                    <i className="fa-solid fa-spinner fa-spin"></i>
                  ) : (
                    <i className="fa-solid fa-paper-plane"></i>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>

        {/* MAIN FOOTER */}
        <div className="footer-main">
          <div className="footer-grid">
            <div className="footer-column footer-brand">
              <h2 className="footer-logo">
                <span>Versa</span>core
              </h2>

              <p>
                Your one-stop shop for trendy products, home essentials,
                beauty, gadgets, and more for everyday living.
              </p>

              <div className="social-icons">
                <a
                  href="https://www.facebook.com/share/1JhiY4N1K2/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fa-brands fa-facebook-f"></i>
                </a>

                <a
                  href="https://www.instagram.com/versacore.shopping/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </div>
            </div>

            <div className="footer-column">
              <h3>Shop</h3>
              <Link to="/shop">All Products</Link>
              <Link to="/new-arrivals">New Arrivals</Link>
              <Link to="/deals">Best Deals</Link>
              <Link to="/trending">Trending</Link>
            </div>

            <div className="footer-column">
              <h3>Customer Service</h3>
              <Link to="/trackorder">Track Order</Link>
              <Link to="/shippingPolicy">Shipping Policy</Link>
            </div>

            <div className="footer-column">
              <h3>Company</h3>
              <Link to="/contact">Contact Us</Link>
              <Link to="/privacypolicy">Privacy Policy</Link>
              <Link to="/termscondition">Terms & Conditions</Link>
            </div>

            <div className="footer-column">
              <h3>We Accept</h3>
              <div className="payment-box">
                <span>VISA</span>
                <span>MasterCard</span>
                <span>UPI</span>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>© 2026 Versacore. All Rights Reserved.</p>

            <div className="footer-bottom-links">
              <Link to="/privacypolicy">Privacy</Link>
              <Link to="/termscondition">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default EcommerceFooter;